import { useState, useEffect } from 'react';
import { Customer, Tag, Duration } from '../../../types';
import { supabase } from '../../../lib/supabase';

export function useProjectOptions(isNew: boolean) {
  const [customers, setCustomers] = useState<Customer[]>([]);
  const [allTags, setAllTags] = useState<Tag[]>([]);
  const [durations, setDurations] = useState<Duration[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    loadOptions();
  }, []);

  const loadOptions = async () => {
    setLoading(true);
    try {
      const [customersResponse, tagsResponse, durationsResponse] = await Promise.all([
        supabase.from('customers').select('*'),
        supabase.from('tags').select('*'),
        supabase.from('durations').select('*')
      ]);

      if (customersResponse.error) throw customersResponse.error;
      if (tagsResponse.error) throw tagsResponse.error;
      if (durationsResponse.error) throw durationsResponse.error;

      setCustomers(customersResponse.data);
      setAllTags(tagsResponse.data);
      setDurations(durationsResponse.data);
    } catch (error) {
      console.error('Error loading options:', error);
      setError('Failed to load options');
    } finally {
      setLoading(false);
    }
  };

  return {
    customers,
    allTags,
    durations,
    loading,
    error
  };
}